const requestUrl = {
	//baseUrl:'http://localhost:1234/public/'
	baseUrl:'https://www.xjjgweiguang.com'
}

export {
	requestUrl
}
